

















import Vue from 'vue';
import {Component, Inject, Prop} from 'vue-property-decorator';
import Icon from './Icon.vue';
@Component({
  components: {Icon}
})
export default class CollapseItem extends Vue {
  open = false;
  @Prop({type: String, required: true}) title!: string;
  @Prop(String) name!: string;
  @Inject() eventBus!: Vue;

  mounted() {
    this.eventBus.$on('update:selected', (names: string[]) => {
      this.open = names.indexOf(this.name) >= 0;
    });
  }

  toggle() {
    if (this.open) {
      this.eventBus.$emit('update:removeSelected', this.name);
    } else {
      this.eventBus.$emit('update:addSelected', this.name);
    }
  }


}
